module.exports = __webpack_public_path__ + "media/images/city/080-badshahi-mosque-28e7f5d6da40c47dfac9e74c05ee81f3.svg";